import { Component, computed, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { DatePipe } from '@angular/common';

import { environment } from '@fry/environments/environment';
import { of } from 'rxjs';
import { Version } from '@fry/environments/version';


interface ServerVersions {
  name: string;
  [key:string]: string
}

@Component({
    selector: 'app-version-information',
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
      <ng-container i18n>Version</ng-container>: {{ $serverVersion() }} /
      <span><ng-container i18n>Frontend</ng-container>: {{ $frontendVersion() }}</span>
    `
})
export class VersionInformationComponent {

  private datePipe = inject(DatePipe);
  public frontendVersion: Version = environment.version;
  $serverVersion = signal<string>('Information not available');
  $frontendVersion = computed(() => this.frontendVersionDescription(this.frontendVersion));
  public versionAvailable$ = of(false);

  constructor() {
  }

  ngOnInit() {
    this.init();
  }

  async init() {
    const resp = await fetch('/__version__');

    const version = await resp.json() as ServerVersions;
    this.$serverVersion.set(version.name);
  }

  //
  // Template helpers
  //

  public frontendVersionDescription(version: Version): string {
    // If we have some production version we output that one
    const preReleaseVersions = ['master', 'HEAD'];
    if (preReleaseVersions.indexOf(version.branch) !== -1) {
        return version.version;
    }

    // If we have pre-production we construct detailed information
    const result = [
        `${this.datePipe.transform(version.buildAt as string, 'medium')}`,
        ` - ${version.branch}`,
        ` (${version.hash})`
    ].join('');
    return result;
  }
}
